<template>
  <div>
    <!-- <current-path /> -->
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.contact_message") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
    </v-toolbar>
    <v-container fluid class="filter-area">
      <global-search-filter :queries="queries" ref="search_filter_ref" />
      <v-row>
        <v-col cols="12" sm="3">
          <v-select
            :items="topics"
            item-text="name"
            item-value="id"
            v-model="topic"
            :label="$t('labels.topic')"
            outlined
            @change="handleFitler('topic')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="5" class="text-center">
          <global-toggle-filter
            :queries="toggleQueryies"
            ref="toggle_filter_ref"
          />
        </v-col>

        <v-col cols="12" sm="4" class="text-center">
          <v-btn large @click="ClearAllFilters" class="error">{{
            $t("button.reset")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <!-- table -->
    <wrapping-table
      @on_dialog_close="onDialogClose"
      @get_items="getItems"
      ref="table_ref"
      :headersName="headers"
      pathName="contact-messages"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.user_name }}</td>
        <td class="text-sm-center">{{ item.user_email }}</td>
        <td class="text-sm-center">{{ item.user_phone.phone }}</td>
        <td class="text-sm-center">{{ item.topic.name }}</td>
        <td class="text-sm-center" :title="item.message">
          {{ item.message | truncate }}
        </td>
        <td class="text-sm-center">
          {{ item.date && item.date }}
        </td>
        <td class="text-sm-center">
          <v-chip :class="handleStatus(item.status)">{{
            handleStatus(item.status)
          }}</v-chip>
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleShow(item, index)"
            :title="$t('icon.show')"
            small
            >mdi-eye</v-icon
          >
          <v-icon
            @click="handleDelete(item, index)"
            :title="$t('icon.delete')"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog>
        <v-card-title class="dialog_header">{{
          $t("headings.contact_details")
        }}</v-card-title>
        <v-card-text>
          <v-list flat>
            <v-list-item-group>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :title="$t('labels.name')"> mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :title="$t('labels.name')">{{
                    item.user_name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :title="$t('labels.email')"> mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :title="$t('labels.email')">{{
                    item.user_email
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :title="$t('labels.phone')"> mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :title="$t('labels.phone')">{{
                    item.user_phone && item.user_phone.phone
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon :title="$t('labels.topic')"> mdi-credit-card</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :title="$t('labels.topic')">{{
                    item.topic && item.topic.name
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <span>
                  <v-icon :title="$t('labels.message')">
                    mdi-message</v-icon
                  ></span
                >
                <p style="margin: 30px">{{ item.message }}</p>
                <!-- <v-list-item-icon> </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :title="$t('labels.message')">
                  </v-list-item-title>
                </v-list-item-content> -->
              </v-list-item>
              <v-divider></v-divider>
              <v-btn
                :disabled="item.status === 2"
                :loading="loadingButton"
                class="my-3 error"
                @click="handleUpdate"
                >{{ $t("button.close") }}</v-btn
              >
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </template>
      <!-- dilaog -->
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
import cookie from "js-cookie";
import { ShowData, UpdateData, IndexData } from "@/helpers/apiMethods";
export default {
  name: "contactMessage",

  data() {
    return {
      headers: [
        "name",
        "email",
        "phone",
        "topic",
        "message",
        "date",
        "status",
        "actions",
      ],

      isEdit: false,
      loadingButton: false,
      items: [],
      item: {},
      itemIndex: "",
      locale: cookie.get("language") || "en",
      queries: {
        query: {
          user_name: "",
          user_email: "",
          user_phone: "",
        },
      },
      toggleQueryies: {
        query: {
          seen: "",
          closed: "",
          pending: "",
        },
      },
      topics: [],
      topic: "",
    };
  },
  methods: {
    handleFitler(name) {
      const queries = {};
      queries[name] = this[name];
      if (queries[name] === "") {
        delete queries[name];
        queries[name] = "";
      }
      if (queries[name] !== "") {
        this.$router.push({ query: { ...this.$route.query, ...queries } });
      }
    },
    hadnleGetTopics() {
      IndexData({ reqName: "topics" })
        .then((res) => {
          const { data } = res.data;
          this.topics = data;
        })
        .catch((err) => console.log(err));
    },
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    },
    handleStatus(status) {
      switch (status) {
        case 0:
          return this.$t("labels.pending");

        case 1:
          return this.$t("labels.seen");
        case 2:
          return this.$t("labels.closed");
      }
    },
    onDialogClose() {
      this.isEdit = false;
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleShow(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.$refs.table_ref.toggleDialog();
      this.handleShowData();
    },
    getItems(items) {
      this.items = items;
    },
    handleUpdate() {
      this.loadingButton = true;
      const data = { closed: "closed", _method: "put", locale: this.locale };

      UpdateData({
        reqName: "contact-messages",
        data,
        param: this.item.id,
      })
        .then(() => {
          this.$refs.table_ref.toggleDialog();
          this.onDialogClose();
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loadingButton = false));
    },
    handleShowData() {
      ShowData({ reqName: "contact-messages", param: this.item.id })
        .then((res) => {
          const { contact_message } = res.data;
          this.item = contact_message;
        })
        .catch((err) => console.log(err));
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        this.hadnleGetTopics();
        if (query["topic"]) {
          this["topic"] = Number(query["topic"]);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.Pending {
  background-color: darkorange !important;
}
.Seen {
  background-color: darkgreen !important;
}
.Closed {
  background-color: darkred !important;
}
.Pending,
.Seen,
.Closed {
  color: #fff !important;
  box-shadow: 0 1px 5px #444 !important;
}
</style>
